// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "css/" + {2129: "previewbar",7002: "vitatree",}[chunkId] + ".css"
}